<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-card class="overflow-hidden ">
    <v-app-bar
        color="black"
        dark
        dense
    >
      <v-app-bar-nav-icon color="primary" absolute @click.stop="drawer = !drawer"/>
      <v-toolbar-title class="primary--text">
        How to learn German?
      </v-toolbar-title>
      <img id="logoOnNavbar" src="../assets/deutschDeluxeLogoTextBlue.png"/>
    </v-app-bar>
    <v-navigation-drawer
        class="navigation-drawer"
        v-model="drawer"
        absolute
        left
        temporary
        color="black"
    >
      <div id="logo" class="pt-5">
        <img src="../assets/deutschDeluxeLogoTextBlue.png" style="width: 20%;"/>
      </div>
      <v-list
          nav
          dense
      >
        <v-list-item-group v-model="group">
          <v-list-item v-for="link in links" :to="link.ref" :key="link.name">
            <v-list-item-title>{{ link.name }}</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
    <v-sheet>
      <v-container class="ma-0 pa-0" fluid fill-height primary>
        <slot/>
      </v-container>
    </v-sheet>
  </v-card>
</template>

<script>
export default {
  name: "Navigation",
  data() {
    return {
      drawer: null,
      group: null,
      links: [
        {name: 'Impressum', ref: 'imprint'},
        {name: 'AGBs', ref: 'agbs'},
        {name: 'Datenschutz', ref: 'dataprivacy'},
      ],
    }
  },
}
</script>

<style scoped>
.v-toolbar__title {
  margin-left: auto;
  margin-right: auto;
}

#logoOnNavbar {
  position: absolute;
  width: 10%;
  right: 5%;
}

.navigation-drawer .v-list-item__title {
  color: var(--var-primary)
}
</style>
